import { WprBaseMngr } from '../WprBaseMngr';
import { WprBaseValidator } from './validation/WprBaseValidator';
import { WprErrorMngr } from '../error/WprErrorMngr';
import { WprSettingInfo } from '../WprSettingInfo';
import { WprRequiredValidator } from './validation/validator/WprRequiredValidator';
import { WprMinValidator } from './validation/validator/WprMinValidator';
import { WprMaxValidator } from './validation/validator/WprMaxValidator';
import { WprMinLengthValidator } from './validation/validator/WprMinLengthValidator';
import { WprMaxLengthValidator } from './validation/validator/WprMaxLengthValidator';
import { WprNumberValidator } from './validation/validator/WprNumberValidator';
import { WprHankakuValidator } from './validation/validator/WprHankakuValidator';
import { WprHankakuKValidator } from './validation/validator/WprHankakuKValidator';
import { WprValidatorSetter } from './validation/WprValidatorSetter';
import { WprHankakuKanaValidator } from './validation/validator/WprHankakuKanaValidator';
import { WprZKanaValidator } from './validation/validator/WprZKanaValidator';
import { WprBaseViewInfo } from './WprBaseViewInfo';
import { WprMailAddressValidator } from './validation/validator/WprMailAddressValidator';
import { WprZenkakuValidator } from './validation/validator/WprZenkakuValidator';
import { WprBaseConverter } from './convert/WprBaseConverter';
import { WprCommaConverter } from './convert/converter/WprCommaConverter';
import { WprConverterSetter } from './convert/WprConverterSetter';
import { WprAlphabetValidator } from './validation/validator/WprHankakuValidator copy';
import { WprGenderConverter } from './convert/converter/WprGenderConverter';
import { WprBaseFrameworkComponent } from '../component/base/WprBaseFrameworkComponent';
import { WprSwitch } from '../component/route/WprSwitch';
import { Route } from 'react-router-dom';
import React from 'react';
import { ROOT_TITLE, VIEW_DEFINE_JSON } from '../../common/viewDefine';

/**
 * ビュー管理機能
 */
export class WprViewMngr extends WprBaseMngr {
	// private 変数  ------------------------------------------------------------
	private m_ValidatorMap: Map<string, WprBaseValidator>	= new Map<string, WprBaseValidator>();	// バリデータマップ
	private m_ConverterMap: Map<string, WprBaseConverter>	= new Map<string, WprBaseConverter>();	// コンバータマップ
	private m_ErrorMngr: WprErrorMngr						= null;									// エラー管理機能
	private m_ActiveViewList: WprBaseViewInfo[]				= new Array();							// アクティブビュー情報リスト
	private m_ViewStack: string[]							= new Array();							// ビュー遷移スタック
	private m_CurRouteViewInfo: WprBaseViewInfo				= null;									// 現在のルートビュー情報
	private m_NoMoveList: string[]							= new Array();							// ブラウザバック禁止Pathリスト
	private m_NoUpdateList: string[]						= new Array();							// 更新禁止Pathリスト
	private m_StartValidate: string							= null;									// 開始バリデーション
	private m_StopBlur: boolean								= false;								// Blurイベント停止フラグ
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('ビュー管理機能');
	}
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** アクティブビュー情報リスト */
	public get activeViewList(): WprBaseViewInfo[] 	{ return this.m_ActiveViewList; }
	/** 開始バリデーション */
	public get startValidate(): string			 	{ return this.m_StartValidate; 	}	public set startValidate(startValidate: string) { this.m_StartValidate = startValidate;	}
	/** Blurイベント停止フラグ */
	public get isStopBlurEvent(): boolean		 	{ return this.m_StopBlur; 		}
	// --------------------------------------------------------------------------

	// override メソッド	-----------------------------------------------------
	/**
	 * 初期化処理
	 * @param loader データローダ
	 * @param setting 設定情報
	 */
	public initialize(loader: WprBaseFrameworkComponent, setting: WprSettingInfo): void {
		this.addValidator(new WprRequiredValidator());
		this.addValidator(new WprMinValidator());
		this.addValidator(new WprMaxValidator());
		this.addValidator(new WprMinLengthValidator());
		this.addValidator(new WprMaxLengthValidator());
		this.addValidator(new WprNumberValidator());
		this.addValidator(new WprHankakuValidator());
		this.addValidator(new WprHankakuKValidator());
		this.addValidator(new WprHankakuKanaValidator());
		this.addValidator(new WprZKanaValidator());
		this.addValidator(new WprMailAddressValidator());
		this.addValidator(new WprZenkakuValidator());
		this.addValidator(new WprAlphabetValidator());
		loader.onRegisterValidator(new WprValidatorSetter(this));
		/* ATODE
		this.m_DefaultDialogConfig = setting.defaultDialogConfig;
		*/
		this.addConverter(new WprCommaConverter());
		this.addConverter(new WprGenderConverter());
		loader.onRegisterConverter(new WprConverterSetter(this));
		window.addEventListener('popstate', this.onPopState.bind(this), true);
		window.addEventListener('beforeunload', this.onBeforeUnload.bind(this), true);
		let ua = window.navigator.userAgent.toLowerCase();
		window.addEventListener('keydown', this.onKeydown.bind(this), true);
	}

	/**
	 * 他の管理機能設定処理
	 * @param mngrMap 管理機能マップ
	 */
	public setManager(mngrMap: Map<string, WprBaseMngr>): void {
		this.m_ErrorMngr = mngrMap.get('エラー管理機能') as WprErrorMngr;
	}
	// --------------------------------------------------------------------------

	private onKeydown(event: any) {
		if (event.ctrlKey === true && event.keyCode === 123) {
			event.returnValue = false;
			// alert('viewer表示');
		}
	}

	// イベント	------------------------------------------------------------------
	/**
	 * ブラウザバックイベント処理
	 */
	private onPopState(): void {
		if (this.m_CurRouteViewInfo) {
			if (this.m_ViewStack.length > 0) {
				const path = this.m_ViewStack[0];
				if (this.m_NoMoveList.includes(path) === true) {
					history.pushState(null, null, null);
					this.m_CurRouteViewInfo.props.history.replace(path);
					let title = this.m_CurRouteViewInfo.getDocumentTitle();
					if (title != null) {
						document.title = '';
						document.title = title;
					}
				}
			}
		}
	}

	/**
	 * アンロードイベント処理
	 */
	private onBeforeUnload(e: any): void {
		if (this.m_ViewStack.length > 0) {
			if (this.m_NoUpdateList.includes(this.m_ViewStack[0]) === true)
				e.returnValue = '更新してよろしいですか？';
		}
	}
	// --------------------------------------------------------------------------

	// public メソッド	----------------------------------------------------------
	/**
	 * バリデータ登録
	 * @param validator バリデータ
	 */
	public addValidator(validator: WprBaseValidator): void {
		if (this.m_ValidatorMap.has(validator.name) === false)
			this.m_ValidatorMap.set(validator.name, validator);
		else
			this.m_ErrorMngr.addErrorLog('WprLoader', `同一のvalidatorが既に登録されています。[${validator.name}]`);
	}

	/**
	 * バリデータ取得処理
	 * @param name バリデータ名
	 */
	public getValidator(name: string): WprBaseValidator {
		if (this.m_ValidatorMap.has(name) === true)
			return this.m_ValidatorMap.get(name);
		this.m_ErrorMngr.addErrorLog('WprViewMngr', `登録されていないvalidatorです。[${name}]`);
		return null;
	}

	/**
	 * カスタムメッセージ設定(コントロールの説明を含める場合は「%desc%」を使用する)
	 * @param name バリデータ名
	 * @param message カスタムメッセージ
	 */
	public setCustomMessage(name: string, message: string): void {
		if (this.m_ValidatorMap.has(name) === true) {
			const validator = this.m_ValidatorMap.get(name);
			validator.customMessage = message;
			validator.isCustom = true;
		}
		else {
			this.m_ErrorMngr.addErrorLog('WprViewMngr', `setCustomMessage:登録されていないvalidatorです。[${name}]`);
		}
	}

	/**
	 * コンバータ登録
	 * @param converter コンバータ
	 */
	public addConverter(converter: WprBaseConverter): void {
		if (this.m_ConverterMap.has(converter.name) === false) {
			this.m_ConverterMap.set(converter.name, converter);
		}
		else {
			this.m_ErrorMngr.addErrorLog('WprLoader', `同一のコンバータが既に登録されています。[${converter.name}]`);
		}
	}

	/**
	 * コンバータ取得処理
	 * @param name コンバータ名
	 */
	public getConverter(name: string): WprBaseConverter {
		if (this.m_ConverterMap.has(name) === true) {
			return this.m_ConverterMap.get(name);
		}
		else {
			this.m_ErrorMngr.addErrorLog('WprViewMngr', `登録されていないコンバータです。[${name}]`);
		}
		return null;
	}

	/**
	 * アクティブビュー情報追加
	 * @param viewInfo ビュー情報
	 */
	public addViewInfo(viewInfo: WprBaseViewInfo): void {
		if (viewInfo.props.match && viewInfo.isRouteView === true) {
			this.m_CurRouteViewInfo = viewInfo;
			const path = viewInfo.props.match.path;
			if (this.m_ViewStack.length === 0 || this.m_ViewStack[0] !== path) {
				const vname = viewInfo.name;
				this.m_ErrorMngr.addInfoLog('WprViewMngr', `View遷移。[${path}][${vname}]`);
				this.m_ViewStack.unshift(path);
				/* log
				console.info(`push -> ${viewInfo.name}`);
				console.info(`count = ${this.m_ViewStack.length}`);
				this.m_ViewStack.forEach((svname) => {
					console.info(`  ${svname}`);
				});
				*/
			}
		}
		for(const vinfo of this.m_ActiveViewList) {
			if (vinfo.name === viewInfo.name) {
				this.m_ErrorMngr.addWarningLog('WprViewMngr', `同一のビュー名が指定されています。[${viewInfo.name}][${viewInfo.objectName}][${vinfo.objectName}]`);
				break;
			}
		}
		this.m_ActiveViewList.push(viewInfo);
	}

	public addViewStack(viewName: string): void {
		if (!this.m_ViewStack.includes(viewName))
			this.m_ViewStack.unshift(viewName);
	}

	/**
	 * アクティブビュー情報削除
	 * @param viewInfo ビュー情報
	 */
	public deleteViewInfo(viewInfo: WprBaseViewInfo): void {
		this.m_ErrorMngr.addDebugLog('WprViewMngr', `*** View終了 *** [${viewInfo.objectName}]`);
		if (this.m_ActiveViewList.includes(viewInfo)) {
			const idx = this.m_ActiveViewList.indexOf(viewInfo);
			this.m_ActiveViewList.splice(idx, 1);
		}
		let formId = null;
		if (viewInfo.getScopeInfo() != null)
			viewInfo.getScopeInfo().deleteDIInfo(viewInfo);
		if (viewInfo.globalScopeInfo != null)
			viewInfo.globalScopeInfo.deleteDIInfo(viewInfo);
		if (viewInfo === this.m_CurRouteViewInfo)
			this.m_CurRouteViewInfo = null;
	}

	/**
	 * スコープ更新プロパティ情報設定処理
	 */
	public setScopeUpdateProperty(): void {
		this.m_ActiveViewList.forEach(viewInfo => {
			viewInfo.setScopeUpdateProperty();
		});
	}

	/**
	 * スイッチコンポーネント設定
	 * @param sw スイッチコンポーネント
	 */
	public setSwitchComponet(sw: WprSwitch): void {
		const firstRedirectMap = new Map<string, string>();
		React.Children.forEach(sw.props.children, (child) => {
			const route = child as Route;
			if (route) {
				const path = route.props.path as string;
				if (route.props['noMove'])
					this.m_NoMoveList.push(path);
				if (route.props['noUpdate'])
					this.m_NoUpdateList.push(path);
				if (route.props['firstRedirect'])
					firstRedirectMap.set(path, route.props['firstRedirect']);
			}
		});
		if (this.m_ViewStack.length > 0) {
			const path = this.m_ViewStack[0];
			if (firstRedirectMap.has(path) === true)
				this.m_CurRouteViewInfo.props.history.replace(firstRedirectMap.get(path));
		}
	}

	/**
	 * Blurイベント停止処理
	 */
	public stopBlurEvent() {
		this.m_StopBlur = true;
	}

	/**
	 * Blurイベント再開処理
	 */
	public restartBlurEvent() {
		this.m_StopBlur = false;
	}
	// --------------------------------------------------------------------------
}